export default defineNuxtRouteMiddleware((_to, _from) => {
  const auth = useAuth()

  if (auth.userLevel === 'admin') return

  setTimeout(() => {
    useToast({
      severity: 'error',
      detail: '관리자 계정이 필요합니다.',
    })
  }, 500)
  return navigateTo({ path: '/dashboard' })
})
